/**
 * Business details the policy renders verbatim.
 *
 * ev-portal-app has its own copy of this file — the two apps are separate
 * builds with no shared package, so a change here must be made there too.
 */
export const PLACEHOLDER = {
  entity: "Ecohive Inc",
  email: "info@ecohive.ca",
  address: "10 Four Seasons Place, 10th Floor, Toronto, ON M9B 6H7, Canada",
} as const;
